(() => {
  if (window.__caleoFreeShippingV14Loaded) {
    if (typeof window.__caleoFreeShippingRefresh === 'function') {
      window.__caleoFreeShippingRefresh();
    }
    return;
  }

  window.__caleoFreeShippingV14Loaded = true;

  const ROUTES = (window.theme && window.theme.routes) || (window.Shopify && window.Shopify.routes) || {};
  const CART_URL = (ROUTES.cart_url || '/cart') + '.js';
  const PRODUCT_SHIPPING_KEY = 'caleo-product-shipping-quote';
  const CART_ENDPOINT_PATTERN = /\/cart\/(add|change|update|clear)(\.js)?/;
  const REFRESH_DELAYS = [100, 500];

  let lastCart = null;
  let cartPromise = null;
  let updateTimer = null;
  let shippingObserver = null;
  let bodyObserver = null;
  let lastShippingSignature = '';

  function getDefaultThresholdCents() {
    const threshold = Number(window.CALEO_FREE_SHIPPING_THRESHOLD_CENTS || 99900);
    return Number.isFinite(threshold) && threshold > 0 ? threshold : 99900;
  }

  function getDefaultThresholdLabel(currency) {
    return window.CALEO_FREE_SHIPPING_THRESHOLD_LABEL || formatMoney(getDefaultThresholdCents(), currency || getCurrency());
  }

  function formatMoney(cents, currency) {
    const value = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
        style: 'currency',
        currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL'
      }).format(value);
    } catch (error) {
      return `R$ ${value.toFixed(2).replace('.', ',')}`;
    }
  }

  function escapeHTML(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function highlightFreeShipping(text) {
    return escapeHTML(text).replace(/frete grátis/gi, (match) => `<span class="cfs-highlight">${match}</span>`);
  }

  function setHTML(element, html) {
    if (element) element.innerHTML = html;
  }

  function getCart(force = false) {
    if (!force && lastCart) return Promise.resolve(lastCart);
    if (!force && cartPromise) return cartPromise;

    cartPromise = fetch(CART_URL, { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((cart) => {
        lastCart = cart;
        cartPromise = null;
        return cart;
      })
      .catch(() => {
        cartPromise = null;
        return lastCart || { total_price: 0, item_count: 0, currency: 'BRL' };
      });

    return cartPromise;
  }

  function refreshCart() {
    lastCart = null;
    return getCart(true);
  }

  function scheduleUpdate(delay = 120, forceCart = true) {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(() => updateAll(forceCart), delay);
  }

  function scheduleCartRefreshes() {
    REFRESH_DELAYS.forEach((delay) => {
      window.setTimeout(() => scheduleUpdate(40, true), delay);
    });
  }

  function getCurrency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL';
  }

  function parseCartFromMiniCartHTML(html) {
    if (!html || typeof html !== 'string') return null;

    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const summary = doc.querySelector('[data-mini-cart-summary]');

      if (!summary) return null;

      const total = Number(summary.dataset.cartTotalCents || 0);

      if (!Number.isFinite(total)) return null;

      return {
        total_price: total,
        item_count: null,
        currency: getCurrency()
      };
    } catch (error) {
      return null;
    }
  }

  function parseCartFromSections(sections) {
    if (!sections || typeof sections !== 'object') return null;

    for (const key of Object.keys(sections)) {
      const parsed = parseCartFromMiniCartHTML(sections[key]);
      if (parsed) return parsed;
    }

    return null;
  }

  function getCartFromCurrentMiniCartDOM() {
    const summary = document.querySelector('[data-mini-cart-summary]');
    if (!summary) return null;

    const total = Number(summary.dataset.cartTotalCents || 0);

    if (!Number.isFinite(total)) return null;

    return {
      total_price: total,
      item_count: null,
      currency: getCurrency()
    };
  }

  function normalizeCartPayload(payload) {
    if (!payload) return null;

    if (typeof payload === 'string') {
      try {
        payload = JSON.parse(payload);
      } catch (error) {
        return null;
      }
    }

    if (payload && payload.detail) {
      return normalizeCartPayload(payload.detail.cart || payload.detail.cartData || payload.detail.product || payload.detail);
    }

    if (payload && payload.cartData) {
      return normalizeCartPayload(payload.cartData);
    }

    if (payload && payload.product) {
      return normalizeCartPayload(payload.product);
    }

    if (payload && typeof payload.total_price === 'number') {
      return payload;
    }

    if (payload && payload.sections) {
      const parsedFromSections = parseCartFromSections(payload.sections);
      if (parsedFromSections) {
        if (typeof payload.item_count === 'number') parsedFromSections.item_count = payload.item_count;
        if (payload.currency) parsedFromSections.currency = payload.currency;
        return parsedFromSections;
      }
    }

    return null;
  }

  function applyCartPayload(payload) {
    const cart = normalizeCartPayload(payload);

    if (!cart || typeof cart.total_price !== 'number') return false;

    lastCart = cart;
    updateAll(false, cart);

    return true;
  }

  function updateFromMiniCartDomOrFetch() {
    const cart = getCartFromCurrentMiniCartDOM();

    if (cart) {
      lastCart = cart;
      updateAll(false, cart);
      return;
    }

    scheduleCartRefreshes();
  }

  function updateAll(forceCart = true, cartFromEvent = null) {
    const promise = cartFromEvent ? Promise.resolve(cartFromEvent) : (forceCart ? refreshCart() : getCart(false));

    promise.then((cart) => {
      document.querySelectorAll('caleo-product-shipping-goal').forEach((element) => {
        element.cart = cart;
        if (typeof element.render === 'function') element.render();
      });

      document.querySelectorAll('caleo-cart-shipping-goal').forEach((element) => {
        if (typeof element.renderFromCart === 'function') element.renderFromCart(cart);
      });
    });
  }

  function parseDays(text) {
    const value = String(text || '').toLowerCase();
    const match = value.match(/(\d+)\s*dias?\s*[úu]teis?/) || value.match(/(\d+)\s*dias?/);
    return match ? Number(match[1]) : null;
  }

  function addBusinessDays(date, days) {
    const result = new Date(date);
    let count = 0;

    while (count < days) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) count += 1;
    }

    return result;
  }

  function getWeekdayShort(date) {
    const weekday = date.toLocaleDateString('pt-BR', { weekday: 'long' }).replace('-feira', '');
    return weekday.charAt(0).toUpperCase() + weekday.slice(1);
  }

  function getDeliveryLabel(data) {
    if (!data) return '';

    const days = Number(data.deliveryDays);

    if (Number.isFinite(days) && days >= 0 && days < 9999) {
      try {
        const date = addBusinessDays(new Date(), days);
        const weekday = getWeekdayShort(date);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');

        return `receba na ${weekday}, ${day}/${month}`;
      } catch (error) {}
    }

    if (data.shippingDate) return `receba em até ${data.shippingDate}`;
    if (data.deliveryDateLabel) return `receba na ${data.deliveryDateLabel}`;

    return '';
  }

  function getStorages() {
    const storages = [];

    try {
      if (window.localStorage) storages.push(window.localStorage);
    } catch (error) {}

    try {
      if (window.sessionStorage) storages.push(window.sessionStorage);
    } catch (error) {}

    return storages;
  }

  function saveProductShipping(data) {
    if (!data || typeof data !== 'object') return;

    const signature = JSON.stringify({
      carrierName: data.carrierName || '',
      shippingDate: data.shippingDate || '',
      deliveryDays: data.deliveryDays || '',
      priceLabel: data.priceLabel || '',
      zipcode: data.zipcode || ''
    });

    if (signature === lastShippingSignature) return;
    lastShippingSignature = signature;

    const payload = {
      ...data,
      savedAt: Date.now()
    };

    getStorages().forEach((storage) => {
      try {
        storage.setItem(PRODUCT_SHIPPING_KEY, JSON.stringify(payload));
      } catch (error) {}
    });

    document.dispatchEvent(new CustomEvent('caleo:product-shipping-updated', { detail: payload }));
  }

  function getProductShippingFromStorage() {
    for (const storage of getStorages()) {
      try {
        const raw = storage.getItem(PRODUCT_SHIPPING_KEY);
        if (!raw) continue;

        const data = JSON.parse(raw);
        if (!data || typeof data !== 'object') continue;
        if (data.savedAt && Date.now() - Number(data.savedAt) > 1000 * 60 * 60 * 24 * 7) continue;

        return data;
      } catch (error) {}
    }

    return null;
  }

  function getProductShipping() {
    return parseProductShippingApp() || getProductShippingFromStorage();
  }

  function normalizeKokfyShippingRates(data) {
    if (!Array.isArray(data) || !data.length) return null;

    const parsedRates = data.map((rate) => {
      const shippingDate = rate && rate.shipping_date ? String(rate.shipping_date).trim() : '';
      const deliveryDays = parseDays(shippingDate);

      if (!shippingDate && !(rate && rate.name) && !(rate && rate.price)) return null;

      return {
        source: 'kokfy-api',
        carrierName: rate && rate.name ? String(rate.name).trim() : '',
        shippingDate,
        deliveryDays: Number.isFinite(deliveryDays) ? deliveryDays : 9999,
        priceLabel: rate && rate.price ? String(rate.price).trim() : '',
        zipcode: document.querySelector('#zipcode') ? document.querySelector('#zipcode').value.trim() : ''
      };
    }).filter(Boolean);

    if (!parsedRates.length) return null;

    parsedRates.sort((a, b) => Number(a.deliveryDays || 9999) - Number(b.deliveryDays || 9999));
    return parsedRates[0];
  }

  function parseProductShippingApp() {
    const container = document.querySelector('#calc-carrier');
    if (!container || container.classList.contains('loading')) return null;

    const rates = Array.from(container.querySelectorAll('li'));
    if (!rates.length) return null;

    const parsedRates = rates.map((rate) => {
      const nameElement = rate.querySelector('.ship-name span:first-child');
      const dateElement = rate.querySelector('.ship-name span:nth-child(2)');
      const priceElement = rate.querySelector('.ship-price');
      const shippingDate = dateElement ? dateElement.textContent.trim() : '';
      const deliveryDays = parseDays(shippingDate);

      if (!shippingDate && !priceElement && !nameElement) return null;

      return {
        source: 'kokfy-product-shipping',
        carrierName: nameElement ? nameElement.textContent.trim() : '',
        shippingDate,
        deliveryDays: Number.isFinite(deliveryDays) ? deliveryDays : 9999,
        priceLabel: priceElement ? priceElement.textContent.trim() : '',
        zipcode: document.querySelector('#zipcode') ? document.querySelector('#zipcode').value.trim() : ''
      };
    }).filter(Boolean);

    if (!parsedRates.length) return null;

    parsedRates.sort((a, b) => Number(a.deliveryDays || 9999) - Number(b.deliveryDays || 9999));
    return parsedRates[0];
  }

  function observeProductShippingApp() {
    const attach = () => {
      const target = document.querySelector('#calc-carrier');
      if (!target || target.__caleoFreeShippingObserved) return;

      target.__caleoFreeShippingObserved = true;

      if (shippingObserver) shippingObserver.disconnect();

      shippingObserver = new MutationObserver(() => {
        const data = parseProductShippingApp();
        if (data) saveProductShipping(data);
      });

      shippingObserver.observe(target, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class']
      });

      const data = parseProductShippingApp();
      if (data) saveProductShipping(data);
    };

    attach();

    if (!bodyObserver && document.body) {
      bodyObserver = new MutationObserver(() => attach());
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('click', (event) => {
      if (!event.target || !event.target.closest) return;

      if (event.target.closest('#formKokfyShipping .btnForm, #formKokfyShipping .search_zipcode')) {
        window.setTimeout(attach, 100);
        window.setTimeout(() => {
          const data = parseProductShippingApp();
          if (data) {
            saveProductShipping(data);
            document.querySelectorAll('caleo-product-shipping-goal').forEach((element) => {
              if (typeof element.render === 'function') element.render();
            });
          }
        }, 900);
        window.setTimeout(() => {
          const data = parseProductShippingApp();
          if (data) {
            saveProductShipping(data);
            document.querySelectorAll('caleo-product-shipping-goal').forEach((element) => {
              if (typeof element.render === 'function') element.render();
            });
          }
        }, 1800);
      }
    }, true);
  }

  function setProgress(element, total, threshold) {
    const progress = threshold > 0 ? Math.min(100, Math.max(0, (Number(total || 0) / threshold) * 100)) : 0;
    element.style.setProperty('--cfs-progress', `${progress}%`);
  }

  function bindCartUpdateHooks() {
    document.addEventListener('cart:updated', (event) => {
      if (!applyCartPayload(event)) {
        scheduleCartRefreshes();
      }
    });

    document.addEventListener('ajaxProduct:added', (event) => {
      if (!applyCartPayload(event)) {
        window.setTimeout(updateFromMiniCartDomOrFetch, 80);
        window.setTimeout(updateFromMiniCartDomOrFetch, 360);
        window.setTimeout(() => scheduleUpdate(40, true), 900);
      }
    });

    document.addEventListener('cart:refresh', scheduleCartRefreshes);
    document.addEventListener('cartdrawer:opened', updateFromMiniCartDomOrFetch);
    document.addEventListener('cart:change', scheduleCartRefreshes);

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (!applyCartPayload(event && event.cartData ? event.cartData : event)) {
          window.setTimeout(updateFromMiniCartDomOrFetch, 80);
          window.setTimeout(updateFromMiniCartDomOrFetch, 360);
          window.setTimeout(() => scheduleUpdate(40, true), 900);
        }
      });
    }

    document.addEventListener('click', (event) => {
      if (!event.target || !event.target.closest) return;

      if (event.target.closest('.quantity__button, quantity-input button, cart-remove-button, .cart-remove-button, [data-cart-remove], [href*="/cart/change"]')) {
        window.setTimeout(updateFromMiniCartDomOrFetch, 80);
        window.setTimeout(() => scheduleUpdate(40, true), 420);
      }
    }, true);
  }

  function bindExplicitProductAndCartTriggers() {
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"], product-form form')) return;

      window.setTimeout(updateFromMiniCartDomOrFetch, 180);
      window.setTimeout(updateFromMiniCartDomOrFetch, 520);
      window.setTimeout(() => scheduleUpdate(40, true), 1100);
    }, true);

    document.addEventListener('click', (event) => {
      if (!event.target || !event.target.closest) return;

      const addButton = event.target.closest('button[name="add"], .product-form__submit, [data-add-to-cart], button[type="submit"]');
      const cartButton = event.target.closest('.header__icon--cart, [href="/cart"], [aria-controls*="cart"], [data-cart-drawer-open]');

      if (addButton) {
        window.setTimeout(updateFromMiniCartDomOrFetch, 220);
        window.setTimeout(updateFromMiniCartDomOrFetch, 620);
        window.setTimeout(() => scheduleUpdate(40, true), 1200);
      }

      if (cartButton) {
        window.setTimeout(updateFromMiniCartDomOrFetch, 70);
        window.setTimeout(() => scheduleUpdate(40, true), 420);
      }
    }, true);
  }

  function patchCartRequests() {
    if (window.__caleoFreeShippingFetchPatched || typeof window.fetch !== 'function') return;

    window.__caleoFreeShippingFetchPatched = true;
    const originalFetch = window.fetch;

    window.fetch = function patchedFetch(...args) {
      const request = args[0];
      const url = typeof request === 'string' ? request : request && request.url ? request.url : '';

      return originalFetch.apply(this, args).then((response) => {
        if (url && url.includes('calculo-frete-produto.kokfy.com/api/carrier/shopify')) {
          try {
            response.clone().json().then((payload) => {
              const data = normalizeKokfyShippingRates(payload);
              if (data) {
                saveProductShipping(data);
                window.setTimeout(() => {
                  document.querySelectorAll('caleo-product-shipping-goal').forEach((element) => {
                    if (typeof element.render === 'function') element.render();
                  });
                }, 40);
              }
            }).catch(() => {});
          } catch (error) {}
        }

        if (url && CART_ENDPOINT_PATTERN.test(url)) {
          try {
            response.clone().json().then((payload) => {
              if (!applyCartPayload(payload)) {
                window.setTimeout(updateFromMiniCartDomOrFetch, 120);
                window.setTimeout(() => scheduleUpdate(40, true), 520);
              }
            }).catch(() => {
              scheduleCartRefreshes();
            });
          } catch (error) {
            scheduleCartRefreshes();
          }
        }

        return response;
      });
    };
  }

  class CaleoProductShippingGoal extends HTMLElement {
    connectedCallback() {
      this.threshold = Number(this.dataset.thresholdCents || getDefaultThresholdCents());
      this.currency = this.dataset.currency || 'BRL';
      this.showDelivery = this.dataset.showDelivery !== 'false';
      this.thresholdLabel = this.dataset.thresholdLabel || getDefaultThresholdLabel(this.currency);
      this.title = this.querySelector('[data-cfs-title]');
      this.render = this.render.bind(this);
      this.refresh = this.refresh.bind(this);

      this.bindEvents();
      this.render();
      this.refresh();
    }

    bindEvents() {
      document.addEventListener('cart:updated', this.refresh);
      document.addEventListener('cart:refresh', this.refresh);
      document.addEventListener('cartdrawer:opened', this.refresh);
      document.addEventListener('cart:change', this.refresh);
      document.addEventListener('caleo:product-shipping-updated', this.render);

      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
        this.unsubscribeCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh);
      }
    }

    disconnectedCallback() {
      if (this.unsubscribeCartUpdate) this.unsubscribeCartUpdate();
    }

    refresh() {
      refreshCart().then((cart) => {
        this.cart = cart;
        this.render();
      });
    }

    render() {
      this.title = this.querySelector('[data-cfs-title]');
      this.delivery = this.querySelector('[data-cfs-delivery]');
      const cart = this.cart || lastCart || { total_price: 0, item_count: 0, currency: this.currency };
      const cartTotal = Number(cart.total_price || 0);
      const remaining = Math.max(0, this.threshold - cartTotal);
      const cartQualifies = cartTotal >= this.threshold;
      const shippingData = getProductShipping();
      const deliveryLabel = this.showDelivery ? getDeliveryLabel(shippingData) : '';
      const deliverySuffix = deliveryLabel ? `, <span class="cfs-delivery-highlight">${escapeHTML(deliveryLabel)}</span>` : '';

      this.classList.toggle('is-success', cartQualifies);
      setProgress(this, cartTotal, this.threshold);

    function highlightFreeShipping(text) {
      if (!text) return '';

      return String(text).replace(/frete\s+grátis/gi, '<span class="caleo-shipping-goal__highlight">Frete Grátis</span>');
    }

    if (cartTotal <= 0) {
      setHTML(this.title, highlightFreeShipping(`Ganhe Frete Grátis em compras acima de ${this.thresholdLabel}`) + deliverySuffix);
    } else if (cartQualifies) {
      setHTML(this.title, highlightFreeShipping('Parabéns, você ganhou Frete Grátis em sua compra') + deliverySuffix);
    } else {
      const formatted = formatMoney(remaining, cart.currency || this.currency);
      setHTML(this.title, highlightFreeShipping(`Adicione mais ${formatted} para ganhar Frete Grátis`) + deliverySuffix);
    }
    }
  }

  class CaleoCartShippingGoal extends HTMLElement {
    connectedCallback() {
      this.threshold = Number(this.dataset.thresholdCents || getDefaultThresholdCents());
      this.currency = this.dataset.currency || 'BRL';
      this.title = this.querySelector('[data-cfs-cart-title]');
      this.renderFromTotal(Number(this.dataset.cartTotalCents || 0), { currency: this.currency });
      this.refresh = this.refresh.bind(this);
      this.refresh();
    }

    refresh() {
      refreshCart().then((cart) => this.renderFromCart(cart));
    }

    renderFromCart(cart) {
      this.renderFromTotal(Number(cart.total_price || 0), cart);
    }

    renderFromTotal(total, cart) {
      this.title = this.querySelector('[data-cfs-cart-title]');
      const remaining = Math.max(0, this.threshold - total);
      const qualifies = total >= this.threshold;
      const currency = (cart && cart.currency) || this.currency;

      this.classList.toggle('is-success', qualifies);
      setProgress(this, total, this.threshold);

      if (qualifies) {
        this.title = this.querySelector('[data-cfs-cart-title]');
        setHTML(this.title, highlightFreeShipping('Parabéns, você ganhou Frete Grátis em sua compra'));
      } else {
        const formatted = formatMoney(remaining, currency);
        this.title = this.querySelector('[data-cfs-cart-title]');
        setHTML(this.title, highlightFreeShipping(`Adicione mais ${formatted} para ganhar Frete Grátis`));
      }
    }
  }

  if (!customElements.get('caleo-product-shipping-goal')) {
    customElements.define('caleo-product-shipping-goal', CaleoProductShippingGoal);
  }

  if (!customElements.get('caleo-cart-shipping-goal')) {
    customElements.define('caleo-cart-shipping-goal', CaleoCartShippingGoal);
  }

  observeProductShippingApp();
  bindCartUpdateHooks();
  bindExplicitProductAndCartTriggers();
  patchCartRequests();

  window.__caleoFreeShippingRefresh = () => scheduleUpdate(40, true);

  document.addEventListener('DOMContentLoaded', () => {
    observeProductShippingApp();
    scheduleUpdate(80, true);
  });

  document.addEventListener('shopify:section:load', () => {
    observeProductShippingApp();
    scheduleUpdate(80, true);
  });
})();
